/**
 * mco-mwmo-form.js — submission handler for the native community form on
 * /pages/made-with-mocap-online. POSTs to the mocaponline-c09-mwmo Vercel API.
 */
(function () {
  'use strict';

  if (!/\/pages\/made-with-mocap-online/i.test(location.pathname)) return;

  // Default endpoint = MoCapOnline/mocaponline-c09-mwmo Vercel project's prod URL.
  // Override at runtime by setting <meta name="mco-mwmo-api" content="https://...">
  // before this script loads, in case the deploy uses a custom domain.
  var DEFAULT_API = 'https://mocaponline-c09-mwmo.vercel.app/api/community-submission';

  function apiUrl() {
    var meta = document.querySelector('meta[name="mco-mwmo-api"]');
    return (meta && meta.content) || DEFAULT_API;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var form = document.getElementById('mwmo-form');
    if (!form) return;
    var status = document.getElementById('mwmo-form-status');
    var submit = form.querySelector('.mwmo-form__submit');

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var data = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name) return;
        if (el.type === 'checkbox') {
          data[el.name] = el.checked;
        } else {
          data[el.name] = el.value;
        }
      });

      submit.disabled = true;
      submit.textContent = 'Submitting…';
      status.className = 'mwmo-form__status';
      status.textContent = '';

      fetch(apiUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; });
        })
        .then(function (res) {
          if (res.ok && res.body && res.body.success) {
            status.className = 'mwmo-form__status mwmo-form__status--ok';
            status.textContent = res.body.message || 'Thanks — we got your submission.';
            form.reset();
            submit.textContent = 'Submitted ✓';
          } else {
            var msg = (res.body && res.body.error) || 'Something went wrong. Please try again.';
            status.className = 'mwmo-form__status mwmo-form__status--error';
            status.textContent = msg;
            submit.disabled = false;
            submit.textContent = 'Submit Project';
          }
        })
        .catch(function () {
          status.className = 'mwmo-form__status mwmo-form__status--error';
          status.textContent = "Couldn't reach the server. Check your connection or email MoCap@MotusDigital.com.";
          submit.disabled = false;
          submit.textContent = 'Submit Project';
        });
    });
  }
})();
